import { Modal, Popover } from 'antd';
import React from 'react';
import { CustomButton } from '../../../components/utils/Utils';
import style from './orderModal.module.scss';

const OrderModal = (props) => {

  const { state, set, order } = props;
  const { container, table, tableHeader, tableItem, totals } = style;
  const totalItems = order.products.reduce((acc, curr) => {
    return acc + curr.quantity;
  }, 0);

  return (
    <>
      <Modal
        visible={state}
        footer={null}
        onCancel={() => set(!state)}
        width="1200px"
      >
        <div className={container}>
          <div>
            <div>
              <div>
                <h2>{order?.comboData?.name || order.products[0]?.product?.description} - 
                  Generado por {order?.isSupplierOrder ? 'Proveedor' : 'Farmacia'}
                </h2>
              </div>
              <div>{`(${order?.comboData?.products.length || '1'} Artículos)`}</div>
            </div>
          </div>
          <div>
            <div className={table}>
              <div>
                <div className={tableHeader}>
                  <div>Producto</div>
                  <div>Cantidad</div>
                  <div>Precio farmacia C/IVA</div>
                  <div>Descuento</div>
                  <div>Precio oferta C/IVA</div>
                  <div>Precio total</div>
                </div>
                <div>
                  {order?.products?.map((product) => {
                    let realDiscount = 0;
                    order?.comboData?.products.map((p) => {
                      (product.product._id === p.product._id) ? realDiscount = p.discount : '';
                    });
                    return (
                      <div className={tableItem} key={product.product._id}>
                        <Popover content={product?.product?.description}>
                          <div>{product?.product?.description}</div>
                        </Popover>
                        <div>{product.quantity}</div>
                        <div>${parseFloat(parseFloat(product.product.pharmacyPrice).toFixed(2))}</div>
                        <div>{parseFloat((parseFloat(realDiscount) * 100).toFixed(2))}%</div>
                        <div>${parseFloat(parseFloat(product.pharmacyUnitPriceWithDiscount).toFixed(2))}</div>
                        <div>${parseFloat(parseFloat(product.subtotalWithDiscount).toFixed(2))}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={totals}>
              <div>
                <h3>Total de articulos: {totalItems}</h3>
              </div>
              <div>
                <h3>Total: ${parseFloat(parseFloat(order.orderTotalWithDiscount).toFixed(2))}</h3>
              </div>
            </div>
          </div>
          <div>
            <CustomButton
              onclick={() => set(!state)}
              color="btnOutline"
              size="bg"
              content="CERRAR"
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default OrderModal;
